<template>
  <div class="page-break">
    <el-row>
      <el-col :span="24">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000">
          {{ payableName || companyName }}
        </h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:0px;" :style="{ height: Number(form.lookUp.length) == 0 ? '0px' : '' }">
      <el-col :span="3" v-if="ORDER_TC_ID != 293">
        <img v-if="showCode == 1" :src="imgUrl" style="width: 92%">
      </el-col>
      <el-col v-if="topData.length > 0" :span="showCode == 1 ? 21 : 24" :style="{ height: form.lookUp.length == 0 ? '0px' : '' }">
        <ul style="margin-top: 10px; display: flex; flex-wrap: wrap;" :style="{ height: form.lookUp.length == 0 ? '0px' : '' }">
          <template v-if="showOrderComment">
            <li><span>订单备注</span>:{{ topData[0].ORDER_COMMENT }}</li>
            <li></li>
          </template>
          <li v-if="showProject == 1"><span>项目点</span>:{{ topData[0].PROJECT_NAME }}</li>
          <li v-if="showSupplier == 1"><span>供应商</span>:{{ getSupplier() }}</li>
          <li v-if="receiving == 1"><span>收货方</span>:{{ NEED_tcName }}</li>
          <li v-if="entrust == 1"><span>委托方</span>:{{ topData[0].SUPPLIER_NAME }}</li>
          <li v-if="Distribution == 1">
            <span>配送方</span>:{{ payableName1 ? payableName1 : topData[0].SUPPLIER_NAME }}
          </li>
          <li v-if="showprojectAddress == 1"><span>项目点地址</span>:{{ topData[0].PROJECT_ADDRESS }}</li>
          <li v-if="showSendDay == 1"><span>送货日期</span>:{{ topData[0].SEND_DAY }}</li>
          <li v-if="showReceipt == 1"><span>回单日期</span>:</li>
          <li v-if="showDK == 1"><span>档口</span>:{{ topData[0].DK_NAME }}</li>
          <li v-if="voucher == 1"><span>制单人</span>:{{ managername }}</li>
          <li v-if="contactPerson == 1">
            <span>联系人</span>:{{ getPROJECT(topData[0].PROJECT_TELPHONE || '') }}
          </li>
          <li v-if="orderCode == 1"><span>订单编号</span>:{{ topData[0].ORDER_CODE }}</li>
          <li v-if="showOrderID == 1">
            <span>订单ID</span>:{{ topData[0].ORDER_ID }}
          </li>
          <!-- 送货数量打印且不打实收则显示送货总金额 -->
          <li v-if="printRealFlagAll == 1 && printRealFlag == 0">
            <span>总金额</span>:{{ topData[0].TOTAL_PROJECT_FEE }}
          </li>
          <li v-if="printRealFlagAll == 1 && printRealFlag == 2">
            <span>总金额</span>:{{ topData[0].NEED_PROJECT_FEE }}
          </li>
          <!-- 订购数量打印且不打实收则显示订购总金额 -->
          <li v-if="printRealFlagAll == 1 && printRealFlag == 1">
            <span>总金额</span>:{{ topData[0].TOTAL_PROJECT_FEE }}
          </li>
          <!-- 只要打印实收显示的即为实收总金额 -->
          <li v-if="printRealFlagAll == 1 && printRealFlag == 3">
            <span>总金额</span>:{{ topData[0].REAL_TOTAL_PROJECT_FEE }}
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%">
          <tr class="aa" style="width: 100%">
            <th style="width: 5%">序号</th>
            <th v-if="showProductCode == 1">编码</th>
            <th style="width: 40%">名称</th>
            <th style="width: 10%" v-if="showBRAND == 1">品牌</th>
            <th style="width: 10%" v-if="showSPE == 1">规格</th>
            <th style="width: 5%">单位</th>
            <th style="width: 8%" v-if="showOrderCount == 1">订购数量</th>
            <th style="width: 8%" v-if="showDeliveryCount == 1">送货数量</th>
            <th style="width: 10%" v-if="showPaidCount == 1">实收数量</th>
            <th style="width: 10%" v-if="showProduction == 1">加工/生产日期</th>
            <th style="width: 10%" v-if="showProductionDateOnline == 1">生产日期</th>
            <th style="width: 10%" v-if="showShelf == 1">保质期</th>
            <th style="width: 10%" v-if="showQGP == 1">保质期</th>
            <th v-if="showPrice == 1" style="width: 8%">价格</th>
            <th v-if="展示税率" style="width: 8%">税率</th>
            <th v-if="showSongAllFee == 1" style="width: 8%">送货总金额</th>
            <th v-if="showDingAllFee == 1" style="width: 8%">订购总金额</th>
            <th v-if="showShiAllFee == 1" style="width: 8%">实收总金额</th>
            <th style="width: 15%" v-if="showComent == 1">备注</th>
            <th style="width: 10%" v-if="showWarehouseProductionDate">生产日期</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index" style="width: 100%">
            <td>{{ item.ID }}</td>
            <td v-if="showProductCode == 1">{{ item.PRODUCT_CODE }}</td>
            <td v-if="showShort == 1">{{ item.SHORT_NAME }}</td>
            <td v-if="showShort == 0" style="max-width: 400px; overflow-x: hidden;">{{ item.PRODUCT_NAME }}</td>
            <td v-if="showBRAND == 1">{{ item.BRAND }}</td>
            <td v-if="showSPE == 1">{{ item.SPECIFICATION }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td v-if="showOrderCount == 1">{{ item.PRODUCT_COUNT }}</td>
            <td v-if="showDeliveryCount == 1">{{ item.NEED_COUNT }}</td>
            <td v-if="showPaidCount == 1 && supplierNameStatus !== 1">
              {{ topData[0].STATUA > 3 ? item.REAL_COUNT : '' }}
            </td>
            <td v-if="showPaidCount == 1 && supplierNameStatus == 1">{{ item.REAL_COUNT }}</td>
            <td v-if="showProduction == 1"></td>
            <td v-if="showProductionDateOnline == 1">{{ productionDateOnline }}</td>
            <td v-if="showShelf == 1"></td>
            <td v-if="showQGP == 1">{{ $util.getQGPValue(item) }}</td>
            <td v-if="showPrice == 1 && sinceStatus !== 1">{{ item.PROJECT_PRICE }}</td>
            <td v-if="showPrice == 1 && sinceStatus == 1">{{ item.REAL_PRICE }}</td>
            <td v-if="展示税率">{{ item.OUTPUT_VAT }}</td>
            <!-- 送货数量打印且不打实收则显示送货总金额 -->
            <td v-if="showSongAllFee == 1 && sinceStatus !== 1">
              {{ (Math.round((item.NEED_COUNT * item.PROJECT_PRICE) * 100) / 100).toFixed(2) }}
            </td>
            <td v-if="showSongAllFee == 1 && sinceStatus == 1">
              {{ (Math.round((item.PRODUCT_COUNT * item.REAL_PRICE) * 100) / 100).toFixed(2) }}
            </td>
            <!-- 订购数量打印且不打实收则显示订购总金额 -->
            <td v-if="showDingAllFee == 1 && sinceStatus !== 1">
              {{ Math.round((item.PRODUCT_COUNT * item.PROJECT_PRICE) * 100) / 100 }}
            </td>
            <td v-if="showDingAllFee == 1 && sinceStatus == 1">{{ item.SUPPLIER_TOTAL_FEE }}</td>

            <!-- 只要打印实收显示的即为实收总金额 -->
            <!-- 价格及总金额只有打印价格的时候才显示 -->
            <td v-if="showShiAllFee == 1 && sinceStatus !== 1">{{ item.PROJECT_REAL_FEE }}</td>
            <td v-if="showShiAllFee == 1 && sinceStatus == 1">{{ item.TOTAL_FEE }}</td>
            <td v-if="showComent == 1">{{ item.PRODUCT_COMMENT }}</td>
            <td v-if="showWarehouseProductionDate" :style="{'white-space': item.PRODUCTION_DATE.includes(',') ? 'normal ' : 'nowrap'}">
              {{ item.PRODUCTION_DATE.includes(',') ? item.PRODUCTION_DATE.split(',').join('\n').trim() : item.PRODUCTION_DATE }}
            </td>
          </tr>
        </table>
      </el-col>
      <div style=" position:absolute;right:6%;display:flex;flex-direction: column;font-size:0;">
        <span :style="changeStyle(index)" style="font-size:15px" v-for="(item, index)  in address" :key="index">
          {{ item }}
        </span>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="5" v-if="showDeliveryPersonnel == 1">
        <span>送货人员：</span>
      </el-col>
      <el-col :span="5" v-if="deliveryMember == 1">
        <span>发货人员：</span>
      </el-col>
      <el-col :span="5" v-if="acceptanceTime == 1">
        <span>验收时间：</span>
      </el-col>
      <el-col :span="6" v-if="showAmountPage == 1">
        <!-- <span>本页金额：{{ mainData[0].pageFee }}</span> -->
        <span>本页金额：{{ pageFee }}</span>
      </el-col>
      <el-col :span="5" v-if="deliveryAddress == 1">
        <span>送货线路：{{ topData[0].LINE_NAME }}</span>
      </el-col>
      <el-col :span="5" v-if="deliveryTime == 1">
        <span>发货时间：</span>
      </el-col>
      <el-col :span="5" v-if="showManager == 1">
        <span v-if="ORDER_TC_ID == 293 || supplierNameStatus == 1 || sinceStatus == 1">项目经理：</span>
        <span v-else>项目经理：{{ accociated_person[0].MANAGER_NAME }}</span>
      </el-col>
      <el-col :span="5" v-if="showChef == 1">
        <span v-if="ORDER_TC_ID == 293 && sinceStatus == 1">厨师长：{{ accociated_person[0].DK_LEADER_NAME }}</span>
        <span v-else>厨师长：</span>
      </el-col>
      <el-col :span="5" v-if="acceptancePerson == 1">
        <span>验收人员：</span>
      </el-col>
      <!-- 北京快客利 -->

      <el-col :span="4" v-for="x in ['送货员','炊事班长','给养员','厨房值班员','风气监督员'].filter((x)=> form.footerSet.includes(x))" :key="x">
        <span>{{x}}：</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px" v-if="basketInfo.length">
      <el-col :span="5" v-for="item in basketInfo" :key="item">
        <span>{{ item }}：</span>
      </el-col>
    </el-row>
    <el-row v-if="isShortDocFlag == 2">
      <el-col :span="3" :offset="20" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  projectList,
} from 'api/customerManage';
import http from '@/assets/common/http';

export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      showCode: 0,
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    ASSOCIATED_PERSON: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    isRemarks: {
      type: Number,
      default() {
        return 1;
      },
      required: true,
    },
    manager: String,
    supplier: String,
    acceptanceQRCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      ORDER_TC_ID: sessionStorage.getItem('ORDER_TC_ID') || '',
      supplierNameStatus: Number(sessionStorage.getItem('supplierNameStatus')),
      sinceStatus: Number(sessionStorage.getItem('sinceStatus')),
      companyName: sessionStorage.getItem('name'),
      printName: sessionStorage.getItem('supplierName'),
      payableName: sessionStorage.getItem('name'),
      payableName1: '',
      countFlag: sessionStorage.getItem('countFlag'),
      printRealFlag: 0,
      NEED_tcName: sessionStorage.getItem('NEED_TCNAME'),
      payableForm: {},
      form: {
        TEMPLATE_TYPE: 1,
        lookUpMessage: '',
        supplierName: sessionStorage.getItem('name'),
        address: '',
        tableSet: [

        ],
        checked3: false,
        lookUp: [
        ],
        footerSet: [],
        TYPE: '1',
      },
      isShortDocFlag: 2,
      showProject: 0,
      showCode: 0,
      showDK: 0,
      showSupplier: 0,
      Distribution: 0,
      receiving: 0,
      entrust: 0,
      showSendDay: 0,
      voucher: 0,
      contactPerson: 0,
      orderCode: 0,
      showOrderID: 0,
      showprojectAddress: 0,
      showReceipt: 0,
      showProductCode: 0,
      showDeliveryCount: 0,
      showOrderCount: 0,
      showShort: 0,
      showBRAND: 0,
      showSPE: 0,
      showPaidCount: 0,
      showPrice: 0,
      showAllFee: 0,
      showSongAllFee: 0,
      showDingAllFee: 0,
      showShiAllFee: 0,
      showComent: 0,
      showProduction: 0,
      showShelf: 0,
      showQGP: 0,
      deliveryMember: 0,
      showDeliveryPersonnel: 0,
      deliveryTime: 0,
      deliveryAddress: 0,
      acceptanceTime: 0,
      acceptancePerson: 0,
      showChef: 0,
      showManager: 0,
      showAmountPage: 0,
      printRealFlagAll: 0,
      address: [],
      totalNum: '',
      SUPPLIER_NAME77: '上海内航餐饮服务有限公司(永和食品)',
      projectSitesListData: '',
      accociated_person: [],
      basketInfo: [],
      showOrderComment: false,
      展示税率: false,
      showProductionDateOnline: false,
      showWarehouseProductionDate: false,
      productionDateOnline: sessionStorage.getItem('未签收销售单打印 生产日期(线上填写)') || '',
    };
  },
  computed: {
    pageFee() {
      switch (this.printRealFlag) {
        case 1:
          return this.mainData[0].reduce((total, curr) => total += Number(Number((Number(curr.PRODUCT_COUNT) * Number(curr.PROJECT_PRICE)).toFixed(3)).toFixed(2)), 0).toFixed(2);
        case 2:
          return this.mainData[0].reduce((total, curr) => total += Number(Number((Number(curr.NEED_COUNT) * Number(curr.PROJECT_PRICE)).toFixed(3)).toFixed(2)), 0).toFixed(2);
        case 3:
          return this.mainData[0].reduce((total, curr) => total += Number(Number((Number(curr.REAL_COUNT) * Number(curr.PROJECT_PRICE)).toFixed(3)).toFixed(2)), 0).toFixed(2);

        default:
          return this.mainData[0].reduce((total, curr) => total += Number(Number((Number(curr.PRODUCT_COUNT) * Number(curr.PROJECT_PRICE)).toFixed(3)).toFixed(2)), 0).toFixed(2);
      }
    },
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.accociated_person = this.ASSOCIATED_PERSON;
    this.printSupplier = this.supplier;
    this.imgUrl = this.$util.getURLLocalHost(`/file/${this.acceptanceQRCode}`);

    this.queryForm();
  },
  beforeDestroy() {
    sessionStorage.removeItem('sinceStatus');
    sessionStorage.removeItem('未签收销售单打印 生产日期(线上填写)');
  },

  methods: {
    changeStyle(index) {
      if (index % 4 == 0) {
        return { 'margin-top': '5px' };
      }
    },
    getSupplier() {
      if (this.topData[0].PROJECT_NAME == '上海华为') {
        if (this.payableName1) {
          return this.payableName1;
        }
        if (this.SUPPLIER_NAME77.indexOf('上海内航餐饮服务有限公司(') !== -1) {
          const index1 = this.SUPPLIER_NAME77.indexOf('(');
          const index2 = this.SUPPLIER_NAME77.indexOf(')');
          return this.SUPPLIER_NAME77.substring(index1 + 1, index2);
        }
        return this.topData[0].SUPPLIER_NAME;
      }
      if (this.payableName1) {
        return this.payableName1;
      }
      return this.topData[0].SUPPLIER_NAME;
    },
    getPROJECT(e) {
      e = e.replace('联系人：', '').replace('联系人:', '');
      if (e) {
        return e;
      }
      const data = {
        TC_ID: sessionStorage.getItem('TEM_TCID'),
        STATUS: -1,
        PAGESIZE: 100000,
        PAGEINDEX: 0,
        ADD_POINT: '0.00',
      };
      this.loadSearch = true;
      projectList(data).then((res) => {
        if (res) {
          if (res[0].list[0].MANAGER_NAME) {
            this.projectSitesListData = `${res[0].list[0].MANAGER_NAME}`;
            this.totalNum = res[0].list[0].MANAGER_CELLPHONE;
          } else {
            this.contactPerson = 0;
          }
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loadSearch = false;
      });
      return `${this.projectSitesListData}${this.totalNum}`;
    },
    queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: sessionStorage.getItem('TEM_TCID'),
        IS_SUPPLIER_CLIENT: 0,
      };
      http.post(params).then((result) => {
        if (result[0].TEMPLATE_CONTENT.length !== 0) {
          result[0].TEMPLATE_CONTENT.map((item) => {
            if (item.TEMPLATE_TYPE == 1) {
              this.form = item;
              this.form.TYPE = String(item.TYPE);
              if (item.checked3 == 0) {
                this.form.checked3 = false;
              } else {
                this.form.checked3 = true;
              }
            }
          });
        }
        this.judgment();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    judgment() {
      if (this.topData[0].SUPPLIER_ID == sessionStorage.getItem('tcId')) {
        if (this.form.lookUpMessage) {
          this.payableName = this.form.lookUpMessage;
        }
        if (this.form.supplierName) {
          this.payableName1 = this.form.supplierName;
        }
      } else {
        this.payableName = this.topData[0].SUPPLIER_NAME;
        this.payableName1 = this.topData[0].SUPPLIER_NAME;
      }
      if (this.form.checked3) {
        this.showCode = 1;
      }
      if (this.form.basketSet) {
        this.basketInfo = this.form.basketSet;
      }
      this.form.lookUp.forEach((item) => {
        if (item == '项目点') {
          this.showProject = 1;
        }
        if (item == '档口') {
          this.showDK = 1;
        }
        if (item == '供应商') {
          this.showSupplier = 1;
        }
        if (item == '配送方') {
          this.Distribution = 1;
        }
        if (item == '收货方') {
          this.receiving = 1;
        }
        if (item == '委托方') {
          this.entrust = 1;
        }
        if (item == '送货日期') {
          this.showSendDay = 1;
        }
        if (item == '制单人') {
          this.voucher = 1;
        }
        if (item == '联系人') {
          this.contactPerson = 1;
        }
        if (item == '订单编号') {
          this.orderCode = 1;
        }
        if (item == '订单ID') {
          this.showOrderID = 1;
        }
        if (item == '项目点地址') {
          this.showprojectAddress = 1;
        }
        if (item == '回单日期') {
          this.showReceipt = 1;
        }
        if (item == '总金额') {
          this.printRealFlagAll = 1;
        }
        if (item == '订单备注') {
          this.showOrderComment = true;
        }
      });
      this.form.tableSet.forEach((item) => {
        if (item == '产品编码') {
          this.showProductCode = 1;
        }
        if (item == '订购数量') {
          this.showOrderCount = 1;
        }
        if (item == '使用短名') {
          this.showShort = 1;
        }
        if (item == '品牌') {
          this.showBRAND = 1;
        }
        if (item == '规格') {
          this.showSPE = 1;
        }
        if (item == '送货数量') {
          this.showDeliveryCount = 1;
        }

        if (item == '实收数量') {
          this.showPaidCount = 1;
        }
        if (item == '价格') {
          this.showPrice = 1;
        }
        if (item == '订购总金额') {
          this.showDingAllFee = 1;
          this.printRealFlag = 1;
        }
        if (item == '送货总金额') {
          this.showSongAllFee = 1;
          this.printRealFlag = 2;
        }
        if (item == '实收总金额') {
          this.showShiAllFee = 1;
          this.printRealFlag = 3;
        }
        if (item == '备注') {
          this.showComent = 1;
        }
        if (item == '加工/生产日期') {
          this.showProduction = 1;
        }
        if (item == '保质期') {
          this.showShelf = 1;
        }
        if (item == '保质期（自动带出）') {
          this.showQGP = 1;
        }
        if (item == '税率(常用SKU销项税)') {
          this.展示税率 = true;
        }
        if (item == '生产日期(线上填写)') {
          this.showProductionDateOnline = 1;
        }
        if (item == '标品生产日期') {
          this.showWarehouseProductionDate = true;
        }
      });
      this.form.footerSet.forEach((item) => {
        if (item == '发货人员') {
          this.deliveryMember = 1;
        }
        if (item == '送货人员') {
          this.showDeliveryPersonnel = 1;
        }
        if (item == '发货时间') {
          this.deliveryTime = 1;
        }
        if (item == '送货路线') {
          this.deliveryAddress = 1;
        }
        if (item == '验收时间') {
          this.acceptanceTime = 1;
        }
        if (item == '验收人员') {
          this.acceptancePerson = 1;
        }
        if (item == '厨师长') {
          this.showChef = 1;
        }
        if (item == '项目经理') {
          this.showManager = 1;
        }
        if (item == '本页金额') {
          this.showAmountPage = 1;
        }
      });
      this.address = this.form.address.split('').filter((i) => i && i.trim());
    },
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
  width: 50%;
}

span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 20px;
  font-family: 黑体;
  color: #000;
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}

li span {
  display: inline-block;
  width: 110px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/sellOrderCustommShortTax.vue